import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getAnnouncementImageUrl } from '../utils/imageUrl';

type Props = {
  images?: string[] | null;
  max?: number;
  height?: number;
  /** ex. `/uploads/category-defaults/...` si aucune photo utilisateur */
  categoryDefaultImageUrl?: string | null;
};

export const AnnouncementPhotoRow: React.FC<Props> = ({
  images,
  max = 8,
  height = 160,
  categoryDefaultImageUrl,
}) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('sm'));
  const thumbHeight = compact ? Math.min(height, 120) : height;
  let list = (images ?? []).filter(Boolean).slice(0, max);
  if (list.length === 0 && categoryDefaultImageUrl) {
    list = [categoryDefaultImageUrl];
  }

  if (list.length === 0) {
    return (
      <Box
        sx={{
          height: thumbHeight,
          width: '100%',
          bgcolor: 'action.hover',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Aucune photo
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: '100%',
        maxWidth: '100%',
        pb: 0.5,
      }}
    >
      {list.map((path, i) => (
        <Box
          key={`${path}-${i}`}
          component="img"
          src={getAnnouncementImageUrl(path)}
          alt=""
          sx={{
            width: thumbHeight * 1.15,
            minWidth: thumbHeight * 1.15,
            height: thumbHeight,
            objectFit: 'cover',
            borderRadius: 1,
            flexShrink: 0,
            bgcolor: 'action.hover',
          }}
        />
      ))}
    </Box>
  );
};
